// extracted by mini-css-extract-plugin
module.exports = {"table":"SudokuGrid_table__3GesE","isNew":"SudokuGrid_isNew__32Oe4"};